<form [formGroup]="formGroup" class="form">
  <div class="title" *ngIf="this.title">{{ title }}</div>
  <div class="subtitle" *ngIf="this.subtitle">{{ this.subtitle }}</div>

  <div class="d-flex text-area">
    <mat-form-field class="wide" appearance="outline">
      <textarea
        [ngStyle]="getMinHeigt()"
        class="textarea wide"
        [ngClass]="client ? 'client-textarea' : ''"
        matInput
        placeholder="{{ placeholder }}"
        formControlName="answer"
        (input)="answered($event)"
        cdkTextareaAutosize
        appFocusAndSelect
        [focusAndSelectCondition]="focusAndSelect"
      ></textarea>
    </mat-form-field>
  </div>
</form>
